import React from 'react'
import image from '../../../assets/homepage_add-bg.jpg'
import smallimage from '../../../assets/homepage_bg3.png'
const BannerBoxFive = () => {
  return (
    <>
      <section>
        <div className="container-fluid">
          <div className="add-sec">
            <img className="img-fluid" src={image} alt="" />
            <div className="txt-content d-flex align-items-center">
              <div className="lft-add-content">
                <h3>
                  <span>30%</span>
                  <p>
                    Discount for all Gigabyte products for your first order at Eerna
                  </p>
                </h3>
                <a href="#" className="btn-buy mt-4">
                  BUY NOW
                </a>
              </div>
              <div className="crcle-img">
                <img className="img-fluid" src={smallimage} alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>

    </>
  )
}

export default BannerBoxFive